import type { RecordEntityId, V2Menu } from '@centric-os/types';
import { defineStore, type StateTree } from 'pinia';
import { useStationMenus } from './composables';

interface State extends StateTree {
  stationMenu: V2Menu;
  stationMenus: V2Menu[];
}

export function useStationMenuStore(storeId = 'station-menu') {
  const store = defineStore(storeId, {
    state: (): State => ({
      stationMenu: null,
      stationMenus: [],
    }),
    actions: {
      async getStationBrandMenu(id: RecordEntityId): Promise<void> {
        const response = await this.cdlApi.get<V2Menu>(`/menu/${id}`);
        this.stationMenu = response.data;
      },
      async getAllMenusForStation(ids: RecordEntityId[], stationId: string): Promise<void> {
        const menuPromises: Promise<{ data: V2Menu }>[] = ids.map((id: RecordEntityId) => {
          return this.cdlApi.get<V2Menu>(`/menu/${id}`);
        });
        const { useStationBrandMenus } = useStationMenus();
        const allMenus: any[] = await Promise.all(menuPromises);
        const v2StationMenus = allMenus.map((response: { data: V2Menu }) => response.data);

        // @ts-expect-error FIXME: type not assignable
        this.stationMenus = await useStationBrandMenus(v2StationMenus, stationId);
      },
    },
    pagination: false,
  });
  return store();
}
